import {client} from './services/client'

export  const pharmacies = {
    namespaced:true,
    state:{
        pharmacies:[],
        pharmacieloading:true,
    },
    mutations: {
        SET_PHARMACIE (state,pharmacies){
            state.pharmacies = pharmacies
        },
        SET_PHARMACIELOADING (state,pharmacies){
            state.pharmacieloading = pharmacies
        },


    },
    actions: {
        getPharmacie({commit}){
            commit('SET_PHARMACIELOADING',true)
            return new Promise((resolve,reject)=>{
                client({
                    method : 'get',
                    url:'/pharmacie/get',
                })
                    .then((response)=>{
                        let pharmacies = response.data.pharmacies;
                        console.log(pharmacies);
                        commit('SET_PHARMACIE',pharmacies)
                        commit('SET_PHARMACIELOADING',false)

                    })
                    .catch((error)=>{
                        reject(error);
                    })
            })

        },

        setPharmacie({commit},data){
            commit('SET_PHARMACIELOADING',true)
            return new Promise((resolve,reject)=>{
                client({
                    method : 'post',
                    url:'/pharmacie/save',
                    data:data,
                })
                    .then((response)=>{
                        let pharmacies = response.data.pharmacies;
                        commit('SET_PHARMACIE',pharmacies);
                        commit('SET_PHARMACIELOADING',false)

                        resolve(response);
                    })
                    .catch((error)=>{
                        reject(error);
                    })
            });
        },
        deletePharmacie({commit},id){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'get',
                    url:'/pharmacie/delete/'+id,
                })
                    .then((response)=>{
                        let pharmacies = response.data.pharmacies;
                        commit('SET_PHARMACIE',pharmacies);
                    })
                    .catch((error)=>{
                        reject(error)
                    })
            })
        },
    },
    getters: {
        getPharmacie: state  => {
            return state.pharmacies
        },
    }
};
